module.exports = __webpack_public_path__ + "static/media/arrowwhiteback.a9ed27ae.svg";